var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elemento-pai"},[_c('div',{staticClass:"elemento-filho"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }